<template>
	<th role="columnheader"
		:class="{'cursor-pointer hover:opacity-100': sortable && header.sortable !== false, 'opacity-100': order && Object.keys(order).includes(getSortValue(header)), 'bg-white': !!header.sticky, 'px-0': header.value === 'expand', 'sticky-right': header.text && header.sticky === 'right', 'sticky-left': header.text && header.sticky === 'left'}"
		:style="{width: formatDimension(header.width), minWidth: header.min_width ? formatDimension(header.min_width) : formatDimension(header.width)}"
		@click="handleClick(header)">
		<div class="flex items-center" :class="header.align ? 'justify-' + header.align : 'justify-start'">
			<slot>
				<tooltip v-if="header.abbreviation" top :text="header.text" :class="header.align ? 'text-' + header.align : 'text-left'">
					<span :class="{'whitespace-no-wrap': header.abbreviation.length < 10}">{{ header.abbreviation }}</span>
				</tooltip>
				<span v-else-if="header.text" :class="{'whitespace-no-wrap': header.text && header.text.length < 10}">{{ header.text }}</span>
				<span v-if="header.required" class="text-error">&nbsp;*</span>
				<tooltip v-if="header.help" :text="header.help" with-touch class="ml-4">
					<Icon :icon="icons.help" x-small color="gray-400" />
				</tooltip>
			</slot>
			<template v-if="order && Object.keys(order).includes(getSortValue(header))">
				<Icon small :icon="order[getSortValue(header)] === 'asc' ? icons.asc : icons.desc"/>
				<badge color="gray-300" rounded-full small>{{ Object.keys(order).indexOf(getSortValue(header)) + 1 }}</badge>
			</template>
		</div>
	</th>
</template>

<script>
import {formatDimension} from "@spoferan/spoferan-ts-core";
import {mdiChevronDown, mdiChevronUp} from "@mdi/js";
import {helpIcon} from "../../config";

export default {
    name: 'TableHeaderRowData',

	emits: ['sort'],

    props: {
        // The column (header) of the table
		header: {
            type: Object,
            required: true
        },

        // Whether the columns can be ordered
        sortable: {
            type: Boolean,
            default: false
        },

        // The current sorting order props as keys with the order direction as values
        order: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            icons: {
				help: helpIcon,
                desc: mdiChevronUp,
                asc: mdiChevronDown,
            },
        }
    },

    methods: {
        formatDimension(value) {
            return formatDimension(value)
        },

        handleClick(header) {
            if (this.sortable && header.sortable !== false) {
                this.$emit('sort', header)
            }
        },

        getSortValue(header) {
            return header.sort_value ? header.sort_value : header.value;
        }
    }

}
</script>